import { useHistory, useParams } from 'react-router-dom';
import React, {
	useEffect, useMemo, useState,
} from 'react';
import Logo from '../components/Logo';
import { firebase } from '../components/Firebase';
import throttle from '../utils/throttle';

const ORIENTATION_THRESHOLD = 10;

export const MobilePage = () => {
	const { roomId } = useParams();
	const history = useHistory();
	const roomRef = useMemo(() => (roomId
		? firebase.roomById(roomId) : firebase.createNewRoom()),
	[]);
	const [room, setRoom] = useState(null);

	const [orienMode, setOrienMode] = useState();

	const interpretOrientation = (angle) => {
		if (angle === 90) {
			setOrienMode('chindogu');
		} else if (angle === 270) {
			setOrienMode('jugaad');
		} else {
			setOrienMode(undefined);
		}
	};

	useEffect(() => {
		interpretOrientation(window.screen.orientation.angle);
	}, []);

	useEffect(() => {
		// update body
		document.body.className = orienMode ?? '';

		// update room
		roomRef.update({
			mode: orienMode ?? '',
		});
	}, [orienMode]);

	const onValueChange = (res) => {
		if (res) {
			if (roomId) {
				setRoom(res.toJSON());
			} else {
				history.push(`/desktop/${res.key}`);
			}
		}
	};

	// update the values we receive
	useEffect(() => {
		roomRef.on('value', onValueChange);

		return () => {
			roomRef.off('value', onValueChange);
		};
	}, []);

	// once we connect to the room set inUse true and set false on disconnect
	useEffect(() => {
		roomRef.update({
			inUse: true,
		});

		return () => {
			roomRef.update({
				inUse: false,
			});
		};
	}, [roomRef]);

	const navLeft = () => roomRef.update({
		direction: -1,
	});

	const navRight = () => roomRef.update({
		direction: 1,
	});

	const navStop = () => roomRef.update({
		direction: 0,
	});

	const handleOrientation = throttle(({ beta }) => {
		if (beta) {
			if (beta > ORIENTATION_THRESHOLD) return navRight();
			if (beta < -(ORIENTATION_THRESHOLD)) return navLeft();
		}
		return navStop();
	}, 100);

	const handleResize = () => interpretOrientation(window.screen.orientation.angle);

	useEffect(() => {
		if (typeof window.DeviceMotionEvent?.requestPermission === 'function') {
			window.DeviceMotionEvent.requestPermission();
		}
		if (typeof window.DeviceOrientationEvent?.requestPermission === 'function') {
			window.DeviceOrientationEvent.requestPermission();
		}
		// rotation
		window.ondeviceorientation = handleOrientation;

		// orientation
		window.screen.orientation.onchange = (e) => interpretOrientation(e.angle);
		window.onresize = handleResize;
	}, []);

	return (
		<>
			{
				room ? (
					<>
						<span>
							You have joined Room
							{' '}
							{roomRef.key}
						</span>
						<span>
							In Use:
							{' '}
							{room.inUse.toString()}
						</span>
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'center',
							}}
						>
							<button
								className="primary"
								type="button"
								onTouchStart={navLeft}
								onTouchEnd={navStop}
							>
								{'<'}
							</button>
							<button
								className="primary"
								type="button"
								onTouchStart={navRight}
								onTouchEnd={navStop}
							>
								{'>'}
							</button>
						</div>
					</>
				) : (
					<span>You need to scan the QR code on your desktop</span>
				)
			}
			<div
				style={(orienMode) ? {
					position: 'absolute',
					top: '10px',
					width: '216px',
				} : undefined}
			>
				<Logo mode={orienMode} />
			</div>
		</>
	);
};

export default MobilePage;
